// extracted by mini-css-extract-plugin
export default {"container":"add-settlement-modal_container__umT0Q","element":"add-settlement-modal_element__vdgcI"};